export function getView(layout) {
  return layout !== 'videos'
}
